export const DEFAULT_VARIANT_NAME = 'default'

export enum EXPERIMENT_VARIATION {
  DEFAULT = 'default',
  DEFAULT_2 = 'default_2',
  VARIATION_1 = 'variation_1',
  VARIATION_2 = 'variation_2',
  V1 = 'v1',
  V2 = 'v2',
  V3 = 'v3',
  V4 = 'v4',
  V5 = 'v5',
  V6 = 'v6',
  V7 = 'v7',
  V8 = 'v8',
}
